(function () {
  /* Refresh only: the server renders the initial value. Counts calendar days
     (store-date semantics), not visitor-local hours. Skipped when a preview date is set.
     On the deadline day (0 days) the strip shows data-last-day instead of "0 days". */
  function render(el, days) {
    var text = el.getAttribute('data-text') || '';
    el.textContent = '';
    if (days === 0) {
      el.textContent = el.getAttribute('data-last-day') || '';
      return;
    }
    var parts = text.split('{days}');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (i > 0) {
        var b = document.createElement('b');
        b.setAttribute('data-days', '');
        b.textContent = String(days);
        el.appendChild(b);
        if (days === 1) { part = part.replace(/\bdays\b/, 'day'); }
      }
      if (part) { el.appendChild(document.createTextNode(part)); }
    }
  }
  function update(el) {
    if (el.getAttribute('data-live') !== 'true') { return; }
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('data-deadline') || '');
    if (!m) { return; }
    var now = new Date();
    var end = Date.UTC(+m[1], +m[2] - 1, +m[3]);
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var days = Math.round((end - today) / 86400000);
    if (days < 0) { el.hidden = true; return; }
    render(el, days);
    el.hidden = false;
  }
  function init() {
    var els = document.querySelectorAll('[data-countdown]');
    for (var i = 0; i < els.length; i++) { update(els[i]); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
